<div class="server-settings-root">
	<h1 style="margin-bottom: 20px;">Hudu Settings</h1>
	<form [formGroup]="form">
		<div class="form-group row mb-3">
			<div>
				<input type="checkbox" [formControl]="enabled" />
				<span class="uv-checkbox-label">Enable Hudu</span>
			</div>
		</div>
		<div class="mb-3 row" [ngClass]="{'has-error':form.hasError('noneOrAllSettings') && !serverURL.value}">
			<span class="col-lg-2">Server URL:</span>
			<div class="col-lg-5">
				<input class="form-control" type="text" [formControl]="serverURL" />
			</div>
		</div>
		<div class="mb-3 row" [ngClass]="{'has-error':form.hasError('noneOrAllSettings') && !apiKey.value}">
			<span class="col-lg-2">API Key:</span>
			<div class="col-lg-5">
				<input class="form-control" type="password" [formControl]="apiKey" (keydown)="onPasswordKeyDownHandler($event)" />
			</div>
		</div>
		<div class="mb-3 row">
			<span class="col-lg-2">Device Categories / Layout Map</span>
		</div>

		<div class="mb-3 row">
			<span class="col-lg-2">Default:</span>
			<div class="col-lg-5">
				<input class="form-control" type="text" [formControl]="defaultLayout" (keydown)="onLayoutKeyDownHandler($event)"/>
			</div>
		</div>
		<div class="mb-3 row">
			<span class="col-lg-2">Firewalls:</span>
			<div class="col-lg-5">
				<input class="form-control" type="text" [formControl]="firewallLayout" (keydown)="onLayoutKeyDownHandler($event)"/>
			</div>
		</div>
		<div class="mb-3 row">
			<span class="col-lg-2">Routers:</span>
			<div class="col-lg-5">
				<input class="form-control" type="text" [formControl]="routerLayout" (keydown)="onLayoutKeyDownHandler($event)" />
			</div>
		</div>
		<div class="mb-3 row">
			<span class="col-lg-2">Switches:</span>
			<div class="col-lg-5">
				<input class="form-control" type="text" [formControl]="switchLayout" (keydown)="onLayoutKeyDownHandler($event)" />
			</div>
		</div>
		<div class="mb-3 row">
			<span class="col-lg-2">WLAN Controllers:</span>
			<div class="col-lg-5">
				<input class="form-control" type="text" [formControl]="wlanControllerLayout" (keydown)="onLayoutKeyDownHandler($event)" />
			</div>
		</div>
		<div class="mb-3 row">
			<span class="col-lg-2">Wireless APs:</span>
			<div class="col-lg-5">
				<input class="form-control" type="text" [formControl]="wirelessApLayout" (keydown)="onLayoutKeyDownHandler($event)" />
			</div>
		</div>
		<div class="mb-3 row">
			<span class="col-lg-2">Printers:</span>
			<div class="col-lg-5">
				<input class="form-control" type="text" [formControl]="printerLayout" (keydown)="onLayoutKeyDownHandler($event)" />
			</div>
		</div>
		<div class="mb-3 row">
			<span class="col-lg-2">Virtual Hosts:</span>
			<div class="col-lg-5">
				<input class="form-control" type="text" [formControl]="virtualHostLayout" (keydown)="onLayoutKeyDownHandler($event)" />
			</div>
		</div>
		<div class="mb-3 row">
			<span class="col-lg-2">Virtual Machines:</span>
			<div class="col-lg-5">
				<input class="form-control" type="text" [formControl]="virtualMachineLayout" (keydown)="onLayoutKeyDownHandler($event)" />
			</div>
		</div>
		<div class="mb-3 row">
			<span class="col-lg-2">Windows Servers:</span>
			<div class="col-lg-5">
				<input class="form-control" type="text" [formControl]="windowsServerLayout" (keydown)="onLayoutKeyDownHandler($event)" />
			</div>
		</div>
		<div class="mb-3 row">
			<span class="col-lg-2">Windows:</span>
			<div class="col-lg-5">
				<input class="form-control" type="text" [formControl]="windowsLayout" (keydown)="onLayoutKeyDownHandler($event)" />
			</div>
		</div>
		<div class="mb-3 row">
			<span class="col-lg-2">Apple:</span>
			<div class="col-lg-5">
				<input class="form-control" type="text" [formControl]="appleLayout" (keydown)="onLayoutKeyDownHandler($event)" />
			</div>
		</div>
		<div class="mb-3 row">
			<span class="col-lg-2">IP Phone Managers:</span>
			<div class="col-lg-5">
				<input class="form-control" type="text" [formControl]="ipPhoneManagerLayout" (keydown)="onLayoutKeyDownHandler($event)" />
			</div>
		</div>
		<div class="mb-3 row">
			<span class="col-lg-2">IP Phone:</span>
			<div class="col-lg-5">
				<input class="form-control" type="text" [formControl]="ipPhoneLayout" (keydown)="onLayoutKeyDownHandler($event)" />
			</div>
		</div>

		<div class="hudu-default-settings-divider"></div>
		<div class="row" style="padding-top: 10px;">
			<div style="height: 21px; width: 250px;">
				<button pButton (click)="onSave()" [disabled]="!form.dirty" label="Save Hudu Default Settings"></button>
			</div>
			<div style="height: 21px; width: 250px;">
				<button pButton (click)="testConnection()" [disabled]="!enableTestHuduButton" title="Test/Verify Hudu connection credentials" label="Test Hudu Connection"></button>
			</div>
		</div>
		<div class="hudu-default-settings-divider"></div>
	</form>
</div>